module.exports = __webpack_public_path__ + "img/tee.df6895d3.svg";